var environment = require("../lib/environment")

function processException(e) {
  if (environment.isProduction()) {
    window.Sentry && window.Sentry.captureException(e);
  } else {
    console.error(e);
    throw new Error(e);
  }
}

module.exports = {
  processException: processException
};
